import React, { useState } from 'react';
import axios from 'axios';
import ResumeList from './ResumeList';
import ResumeBuilder from './ResumeBuilder';

const API_BASE_URL = 'https://www.testometer.in:8084/api';

const ResumeApp = () => {
  const [currentView, setCurrentView] = useState('list'); // 'list' or 'builder'
  const [selectedResume, setSelectedResume] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCreateResume = () => {
    setSelectedResume(null);
    setCurrentView('builder');
  };

  const handleEditResume = async (resume) => {
    try {
      setLoading(true);
      // Fetch the full resume with all details
      const response = await axios.get(`${API_BASE_URL}/resumes/${resume.id}`);
      const fullResume = response.data;
      setSelectedResume(fullResume);
      setCurrentView('builder');
    } catch (error) {
      console.error('Error loading resume for editing:', error);
      alert('Error loading resume. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedResume(null);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        marginTop: '80px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner"></div>
          <p>Loading resume...</p>
        </div>
      </div>
    );
  }

  if (currentView === 'builder') {
    return (
      <ResumeBuilder 
        resumeToEdit={selectedResume}
        onBackToList={handleBackToList}
      />
    );
  }

  return (
    <ResumeList 
      onCreateResume={handleCreateResume}
      onEditResume={handleEditResume}
    />
  );
};

export default ResumeApp; 